import React from "react";
import { useState } from "./hooks/useState";
import useCMS from "./hooks/useCMS";
import ErrorMessage from "./ui/ErrorMessage";

export const ERRORS = {
  1: "youhavetocall",
  2: "technicalerror",
  3: "servicedown",
  5: "requireBankIdError",
};

function Error() {
  const cmsData = useCMS();
  const { error } = useState();

  return (
    <ErrorMessage heading={cmsData[ERRORS[error]].headline}>
      {cmsData[ERRORS[error]].information}
    </ErrorMessage>
  );
}

export default Error;
